import { Features } from '../../components/Features';
import { useOfferContext } from '../OfferContext';

export const FeaturesContainer = () => {
  const { features = [] } = useOfferContext();

  if (!features.length) {
    return null;
  }

  return <Features features={features} />;
};
